<template>
  <div>
    <b-row class="mb-2">
      <b-card-body>
        {{ item.FechaAltaMedica | moment('YYYY-MM-DD') }}
        {{ item.FechaReingresoLaboral | moment('YYYY-MM-DD') }}
        {{ item.ReduccionHoraria }}
        {{ item.AdecuacionTareas }}
        {{ item.CambiaFunciones }}
        {{ item.LicenciaCargoPersonal.Id }} {{ item.LicenciaCargoPersonal.DisplayCantidadDias }} | desde: {{ item.LicenciaCargoPersonal.LicenciaDesde | moment('YYYY-MM-DD') }} | hasta: {{ item.LicenciaCargoPersonal.LicenciaHasta | moment('YYYY-MM-DD') }} | articulo: {{ item.LicenciaCargoPersonal.DisplayArticulo }} | cie10: {{ item.LicenciaCargoPersonal.CIE10String  }} | observaciones: {{ item.LicenciaCargoPersonal.Observaciones }}
      </b-card-body>
      <b-card-body>
        <b-button @click="emitirConstanciaAlta(item.LicenciaCargoPersonal.Id)">
          Emitir Alta Médica
          <b-icon icon="file-earmark-medical"></b-icon>
        </b-button>
      </b-card-body>


    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import api from "@/api";
export default {
  name: "ListaSolicitudAltaMedicaItem",
  props: {
    item: Object
  },
  watch: {
  },
  components: {
  },
  computed: {
  },
  data() {
    return {};
  },
  methods: {
    fechaVencimiento(item) {
      var start = moment(item.FechaCreacion);
      var end = moment(item.FechaCreacion).add(48, "h");
      return end.format("DD-MM-YYYY");
    },
    emitirConstanciaAlta(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaAltaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ListaSolicitudAltaMedicaItem.vue